"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CodebookLookupSequence_1 = require("../../core/model/codebook/CodebookLookupSequence");

var Parser_1 = require("../../core/model/data-dictionary/Parser");

var PropDesc_1 = require("../../core/model/data-dictionary/PropDesc");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var ObjectUtils_1 = require("../../core/utils/ObjectUtils");
/**
 * <p>Category of products. Categories should form a tree.</p>
 *
 * @author JMe
 */


var ProductCategory =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ProductCategory, _DomainObject_1$Domai);

  /**
   * Constructs internal product category.
   *
   * @param id the internal id of a category
   * @param externalId the external id of category, i.e. from source data (used for pairing during data import)
   * @param numericId This ID is intended for systems (e.g. Yieldigo) that need numeric IDs.
   * @param name
   * @param parentId id of parent category, can be null > root category
   * @param childrenIds list of direct category children ids
   * @param level identifies level for product category
   * @param classification may be used to help filtering products according to company custom needs
   * @param processed defines whether an instance was processed (intended for import only)
   * @param deleted defines whether an instance was deleted (an application should handle deleted categories case by case)
   */
  function ProductCategory(id, externalId, numericId, name, parentId, childrenIds, level, classification, processed, deleted) {
    var _this;

    _classCallCheck(this, ProductCategory);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProductCategory).call(this));
    _this.id = id;
    _this.externalId = externalId;
    _this.numericId = numericId;
    _this.name = name;
    _this.parentId = parentId;
    _this.childrenIds = childrenIds;
    _this.level = level;
    _this.classification = classification;
    _this.processed = processed;
    _this.deleted = deleted;
    return _this;
  }

  _createClass(ProductCategory, [{
    key: "equals",
    value: function equals(other) {
      if (other instanceof ProductCategory) {
        return this.id === other.id;
      }

      return false;
    }
  }, {
    key: "hashCode",
    value: function hashCode() {
      return ObjectUtils_1.ObjectUtils.hashCode(this.id + this.externalId + this.numericId + this.name + this.parentId + this.childrenIds + this.level + this.classification + this.processed + this.deleted);
    }
  }, {
    key: "isLeaf",
    value: function isLeaf() {
      return this.childrenIds.isEmpty();
    }
  }, {
    key: "isRoot",
    value: function isRoot() {
      return this.parentId === null;
    }
  }]);

  return ProductCategory;
}(DomainObject_1.DomainObject);

exports.ProductCategory = ProductCategory;
ProductCategory.CATEGORIES_LOOKUP = CodebookLookupSequence_1.CodebookLookupSequence.Category; // tslint:disable-next-line:member-ordering

ProductCategory.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ProductCategory.name);
  return {
    id: builder.id('id'),
    externalId: builder.id('externalId'),
    numericId: builder.num('numericId'),
    name: builder.str('name'),
    parentId: builder.opt(builder.id('parentId')),
    childrenIds: builder.listOf(builder.id('childrenIds')),
    level: builder.num('level'),
    classification: builder.opt(new PropDesc_1.PropDesc(new Parser_1.StringMapParser(), {
      nameKey: ProductCategory.name + '_classification'
    })),
    processed: builder.bool('processed'),
    deleted: builder.bool('deleted')
  };
}();